import axios from "axios";

const axiosInstance = axios.create({
  headers: {
    "content-type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error.response && error.response.data)
);

export default axiosInstance;
